/**
 * Qué plantillas puede citar otra (OT-0055): la misma regla que aplica el
 * reporte de completitud del backend (`methodology_completeness.py`,
 * `reference_foreign_methodology`), para que los selectores de los
 * editores no ofrezcan lo que luego se marcaría como problema.
 *
 * Una plantilla de la metodología M cita las de M y las genéricas; una
 * genérica, solo genéricas. Las archivadas no se ofrecen. Una clave del
 * producto y su clon publicado del tenant cuentan una vez: el clon la
 * sustituye en los proyectos (`template_shadowing.shadows_product`).
 */

import type { Template } from '../api/templates'

/** Por `template_key`, la plantilla que se citaría con esa clave. */
export function citableTemplates(
  all: readonly Template[],
  methodologyId: string | null,
): Map<string, Template> {
  const byKey = new Map<string, Template>()
  for (const tpl of all) {
    if (tpl.status === 'archived') continue
    if (tpl.methodology_id !== null && tpl.methodology_id !== methodologyId) continue
    const shadows = tpl.tenant_id !== null && tpl.status === 'published'
    if (!byKey.has(tpl.template_key) || shadows) byKey.set(tpl.template_key, tpl)
  }
  return byKey
}

/** Las citables ordenadas por nombre, para un selector. */
export function sortedCitable(
  all: readonly Template[],
  methodologyId: string | null,
  locale: string,
): Template[] {
  return [...citableTemplates(all, methodologyId).values()].sort((a, b) =>
    a.name.localeCompare(b.name, locale),
  )
}
